import { render, staticRenderFns } from "./BotaoTipoNome.vue?vue&type=template&id=e3da6f52&scoped=true&"
import script from "./BotaoTipoNome.vue?vue&type=script&lang=js&"
export * from "./BotaoTipoNome.vue?vue&type=script&lang=js&"
import style0 from "./BotaoTipoNome.vue?vue&type=style&index=0&id=e3da6f52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3da6f52",
  null
  
)

export default component.exports